<template>
  <div>
    <!-- 订单批量调整 -->
    <el-dialog :title="$t('message.batchAdjustmentOfOrders')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="560px" center>
      <div class="allot">
        <div class="title">
          单子提出时间:
        </div>
        <div class="time">
          <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" type="datetime"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
          <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
            default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="margin-left: 20px;">
          </el-date-picker>
        </div>
        <div class="title">
          人员选择:
        </div>
        <div class="row"> <el-select v-model="datas.y_id" class="item" filterable placeholder="业务">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select></div>
        <div class="row">
          <el-select v-model="datas.g_id" class="item" filterable placeholder="采购">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="row">
          <el-select v-model="datas.p_id" class="item" filterable placeholder="配货">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="adjustClientOrder" class="primary">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    selectList: { type: Array },
    personnelData: { type: Object },
  },
  data() {
    return {

      dialogVisible: false,
      datas: {},
    };
  },
  computed: {
    y() {
      return this.personnelData.y;
    },
    g() {
      return this.personnelData.g;
    },
    p() {
      return this.personnelData.p;
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.datas = {}
      }
    },
  },
  methods: {
    // 分配
    adjustClientOrder() {
      this.datas.user_id = this.selectList[0].id
      this.$api.clienteleApi.adjustClientOrder(this.datas).then((res) => {
        this.$message.success(res.msg)
        this.$parent.clientList();
        this.$parent.selectList = [];
        this.dialogVisible = false;
      });

    },
  },
};
</script>

<style lang='scss' scoped>
.title {
  text-align: left;
  font-size: 16px;

}

/deep/.el-select {
  width: 100%;
}

.time {
  margin-bottom: 20px;
}

.row {
  margin-bottom: 25px;
}

.allot {
  margin: 0 25px;
}
</style>